<template>
  <div class="page_injuryTables">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div>
          <!-- <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
            <el-form-item label="险种名称" size="small">
              <el-input v-model="listQuery.InsuranceName" size="small" clearable></el-input>
            </el-form-item>
          </el-form> -->
        </div>
      </div>
      <div class="top-right">
        <!-- <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button> -->
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>报案理赔</el-breadcrumb-item>
          <el-breadcrumb-item>工伤事故报告</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="addNewAcd">&nbsp;新增+</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column prop="Sort" label="序号" width="50" align="center" fixed="left">
            <template slot-scope="scope">
              {{(listQuery.pageNum - 1) * Number(listQuery.pageSize)  + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column prop="Idcard" label="身份证号码" width="152" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="InjuredEmployeeName" label="工伤员工姓名" width="100" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="ProjectName" label="项目名称" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Service" label="客服" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ServicePhone" label="客服联系电话" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="BranchOffice" label="分公司" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="MainBusiContract" label="主商务合同（法务主体）全称" width="200" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="TimeInjury" label="发生工伤日期" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="TimeInjury1" label="发生工伤时间点" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="EmployeeEduc" label="员工学历" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="EmployeePhone" label="员工联系电话" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="FullNameCustomer" label="客户单位全称" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="CustomerAddress" label="客户单位地址" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="InjuryAddress" label="发生事故地址" width="180" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="PartyLaborContract" label="劳动合同甲方" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="PositionInjury" label="工伤发生时岗位" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="InjuryDetails" label="事故经过" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ApproximateCost" label="大致费用" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="FullNameFirstHospital" label="首次就诊医院全称" width="130" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Diagnosis" label="诊断结论" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="DoctorAdvice" label="医生建议" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="InsurePosition" label="商保参保时岗位" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="InsureCategory" label="商保参保时职业类别" width="150" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="IsHospitalized" label="是否住院" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="InjuryDegree" label="工伤程度" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="IsTrafficInjury" label="是否交通事故" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="LiabilityJudTrafficInjury" label="交通事故员工的责任判定" width="180" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="WorkplaceInjuryPlace" label="工伤发生地（省市）" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="FullNameSocialSecurity" label="第一申报方（社保全称）" width="170" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="InInsureTime" label="参保时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="SecondApplicant" label="第二申报方（商保1）" width="170" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="InInsureTime2" label="参保时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ThirdReporting" label="第三申报方（商保2）" width="170" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="InInsureTime3" label="参保时间" width="120" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column prop="Remark" label="工伤事故报告备注" width="140" :show-overflow-tooltip="true" align="center"></el-table-column>

          <el-table-column label="操作" align="center" fixed="right" width="160px">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="editAcd(row)">编辑</el-button>
                <el-button type="text" @click="getReport(row)">导出报告</el-button>
                <el-popconfirm :title="'请确定身份证为' + row.Idcard + ' 的事故报告作废？'" @confirm="delAcd(row)" style="margin-left: 10px;">
                  <el-button type="text" slot="reference">作废</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="新增" :visible.sync="showAdd" width="1050px">
      <div class="formData">
        <el-form :model="formData" :inline="true" ref="formData" :rules="rules" label-width="170px">
          <el-form-item label="身份证号码" prop="Idcard">
            <el-input v-model.trim="formData.Idcard" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="工伤员工姓名" prop="InjuredEmployeeName">
            <el-input v-model="formData.InjuredEmployeeName" disabled style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="项目名称" prop="ProjectName">
            <el-select v-model="formData.ProjectName" placeholder="" value-key="Projectid" size="small" style="width: 300px;" clearable filterable>
              <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客服" prop="Service">
            <el-input v-model="formData.Service" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="客服联系电话" prop="ServicePhone">
            <el-input v-model="formData.ServicePhone" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="BranchOffice">
            <template #label>
              <span>分公司
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>“提交表单人员”自己所在（归属）的公司。</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.BranchOffice" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="MainBusiContract">
            <template #label>
              <span>主商务合同（法务主体）全称
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div class="agg">“主商务合同（法务主体）”，即与“客户单位”合作的“我司抬头”，亦是“（费用）隶属公司”。</div>
                    <div>例如：宁波英普瑞特供应链管理有限公司/宁波杰博人力资源有限公司等</div>
                    <div class="tipsItem agg">注：“杰博体系自有员工”根据实际“发薪公司”填写。</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-select v-model="formData.MainBusiContract" placeholder="" clearable filterable style="width:300px" size="small">
              <el-option v-for="(item,index) in legList" :key="index" :label="item.CompanyName" :value="item.CompanyName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发生工伤日期" prop="TimeInjury">
            <el-date-picker type="date" placeholder="" v-model="formData.TimeInjury" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="发生工伤时间" prop="TimeInjury1">
            <el-time-picker v-model="formData.TimeInjury1" format="HH:mm" value-format="HH:mm"  size="small" placeholder="" style="width:300px">
            </el-time-picker>
          </el-form-item>
          <el-form-item label="员工学历" prop="EmployeeEduc">
            <el-input v-model="formData.EmployeeEduc" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="员工联系电话" prop="EmployeePhone">
            <el-input v-model="formData.EmployeePhone" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="客户单位全称" prop="FullNameCustomer">
            <el-input v-model="formData.FullNameCustomer" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="CustomerAddress">
            <template #label>
              <span>客户单位地址
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>详细地址精确到号</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.CustomerAddress" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="InjuryAddress">
            <template #label>
              <span>发生事故地址
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>单位外（需具体地址）</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.InjuryAddress" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="PartyLaborContract">
            <template #label>
              <span>劳动合同甲方
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>全称</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.PartyLaborContract" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="工伤发生时岗位" prop="PositionInjury">
            <el-input v-model="formData.PositionInjury" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="大致费用" prop="ApproximateCost">
            <el-input v-model="formData.ApproximateCost" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="FullNameFirstHospital">
            <template #label>
              <span>首次就诊医院全称
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>温馨提醒：商保就诊医院要求二级（含）以上公立医院</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.FullNameFirstHospital" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="Diagnosis">
            <template #label>
              <span>诊断结论
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>按照医院出具的“诊断证明书”上的内容进行填写</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.Diagnosis" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="医生建议" prop="DoctorAdvice">
            <el-input v-model="formData.DoctorAdvice" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="商保参保时岗位" prop="InsurePosition">
            <el-input v-model="formData.InsurePosition" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="商保参保时职业类别" prop="InsureCategory">
            <el-select v-model="formData.InsureCategory" placeholder="" clearable size="small" style="width:300px">
              <el-option value="1-4类"></el-option>
              <el-option value="5类"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否住院" prop="IsHospitalized">
            <el-select v-model="formData.IsHospitalized" placeholder="" clearable size="small" style="width:300px">
              <el-option value="是"></el-option>
              <el-option value="否"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工伤程度" prop="InjuryDegree">
            <el-select v-model="formData.InjuryDegree" placeholder="" clearable size="small" style="width:300px">
              <el-option value="死亡"></el-option>
              <el-option value="有骨折"></el-option>
              <el-option value="无骨折，预计有伤残等级"></el-option>
              <el-option value="非以上情况"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否上下班途中交通事故" prop="IsTrafficInjury">
            <el-select v-model="formData.IsTrafficInjury" placeholder="" clearable size="small" style="width:300px">
              <el-option value="是"></el-option>
              <el-option value="否"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="交通事故员工责任判定">
            <el-select v-model="formData.LiabilityJudTrafficInjury" placeholder="" clearable size="small" style="width:300px">
              <el-option value="员工无责"></el-option>
              <el-option value="员工次责"></el-option>
              <el-option value="员工同责"></el-option>
              <el-option value="责任未出具"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工伤发生地（省市）" prop="WorkplaceInjuryPlace">
            <el-cascader ref="regAddress" :props="propsAddress" v-model="city" :options="provinces" placeholder="" filterable size="small" style="width:300px" @change="changeCity" clearable></el-cascader>
          </el-form-item>
          <el-form-item label="第一申报方（社保全称）" prop="FullNameSocialSecurity">
            <el-input v-model="formData.FullNameSocialSecurity" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item>
            <template #label>
              <span>参保时间
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>“工伤发生前”最近一次参保时间</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-date-picker type="date" placeholder="" v-model="formData.InInsureTime" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="第二申报方（商保1）" prop="SecondApplicant">
            <el-select v-model="formData.SecondApplicant" placeholder="" clearable size="small" style="width:300px">
              <el-option v-for="(item,index) in insureList" :key="index" :value="item.Bntype"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <template #label>
              <span>参保时间
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>“工伤发生前”最近一次参保时间</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-date-picker type="date" placeholder="" v-model="formData.InInsureTime2" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="第三申报方（商保2）" prop="ThirdReporting">
            <el-input v-model="formData.ThirdReporting" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item>
            <template #label>
              <span>参保时间
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>“工伤发生前”最近一次参保时间</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-date-picker type="date" placeholder="" v-model="formData.InInsureTime3" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="工伤事故报告备注" prop="Remark">
            <el-input v-model="formData.Remark" style="width:300px" size="small"></el-input>
          </el-form-item>
          <div class="injuryTextarea">
            <el-form-item prop="InjuryDetails">
              <template #label>
                <span>事故经过
                  <el-tooltip placement="top" effect="light">
                    <div slot="content" style="width:300px">
                      <div>时间（准确到几点几分）、事故地点（车间）、受伤原因、过程、受伤部位（有骨折的要注明）及诊断结果、治疗医院、大致费用；若是交通事故，事故地点注明清楚发生事故的道路名称，并说明交通事故责任判定的结果</div>
                    </div>
                    <i class="el-icon-question cp"></i>
                  </el-tooltip>
                </span>
              </template>
              <el-input v-model="formData.InjuryDetails" style="width:300px" size="small" type="textarea" maxlength="200" :autosize="{ minRows: 3}" show-word-limit></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAdd = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmSubmit">提 交</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import xz from "../../common";
  import FUN from "../../fun";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    nextTick
  } from 'vue';
  export default {
    data() {
      var validatetIdcard = (rule, value, callback) => {
        if (!this.formData.Idcard) {
          callback(new Error("请输入身份证号码"));
        } else if(this.formData.Idcard.length!=18){
          callback(new Error("请输入正确的身份证号码"));
        }else {
          this.getIdcardInfo(value, (res) => {
            console.log(res);
            if (res) {
              callback();
            } else {
              callback(new Error('该身份证号码未在花名册中'))
            }
          });
        }
      };
      return {
        listQuery: {
          pageNum: 1,
          pageSize: 10,
        },
        tableData: [{
          name: '666'
        }],
        totalCount: 0,
        roletype: localStorage.loginRoletype,
        loading: false,
        showAdd: false,
        formData: {
          city: '',
          Id: '',
          Idcard: '', //身份证
          TimeInjury: '', //发生工伤时间（年-月-日）
          InjuredEmployeeName: '', //工伤员工姓名
          ProjectName: '', //项目名称
          Service: '', //客服
          ServicePhone: '', //客服联系电话
          BranchOffice: '', //分公司
          MainBusiContract: '', //主商务合同（法务主体）全称
          TimeInjury1: '', //发生工伤时间点（几点几分）
          EmployeeEduc: '', //员工学历
          EmployeePhone: '', //员工联系电话
          FullNameCustomer: '', //客户单位全称
          CustomerAddress: '', //客户单位地址
          InjuryAddress: '', //发生事故地址
          PartyLaborContract: '', //劳动合同甲方
          PositionInjury: '', //工伤发生时岗位
          InjuryDetails: '', //事故经过
          ApproximateCost: '', //大致费用
          FullNameFirstHospital: '', //首次就诊医院全称
          Diagnosis: '', //诊断结论
          DoctorAdvice: '', //医生建议
          InsurePosition: '', //商保参保时岗位
          InsureCategory: '', //商保参保时职业类别
          IsHospitalized: '', //是否住院
          InjuryDegree: '', //工伤程度
          IsTrafficInjury: '', //是否上下班途中交通事故
          LiabilityJudTrafficInjury: '', //交通事故员工的责任判定
          WorkplaceInjuryPlace: '', //工伤发生地（省市）
          FullNameSocialSecurity: '', //第一申报方（社保全称）
          InInsureTime: '', //参保时间1
          SecondApplicant: '', //第二申报方（商保1）
          InInsureTime2: '', //参保时间2
          ThirdReporting: '', //第三申报方（商保2）
          InInsureTime3: '', //参保时间3
          Remark: '', //工伤事故报告备注
        },
        city: '',
        rules: {
          Idcard: {
            required: true,
            // message: '请输入身份证',
            trigger: 'blur',
            validator: validatetIdcard,
          },
          TimeInjury: {
            required: true,
            message: '请选择发生工伤时间（年-月-日）',
            trigger: 'change'
          },
          InjuredEmployeeName: {
            required: true,
            message: '请输入工伤员工姓名',
            trigger: 'blur'
          },
          ProjectName: {
            required: true,
            message: '请选择项目名称',
            trigger: 'change'
          },
          Service: {
            required: true,
            message: '请输入客服',
            trigger: 'blur'
          },
          ServicePhone: {
            required: true,
            message: '请输入客服联系电话',
            trigger: 'blur'
          },
          BranchOffice: {
            required: true,
            message: '请输入分公司',
            trigger: 'blur'
          },
          MainBusiContract: {
            required: true,
            message: '请输入主商务合同（法务主体）全称',
            trigger: 'blur'
          },
          TimeInjury1: {
            required: true,
            message: '请选择发生工伤时间点（几点几分）',
            trigger: 'change'
          },
          EmployeeEduc: {
            required: true,
            message: '请输入员工学历',
            trigger: 'blur'
          },
          EmployeePhone: {
            required: true,
            message: '请输入员工联系电话',
            trigger: 'blur'
          },
          FullNameCustomer: {
            required: true,
            message: '请输入客户单位全称',
            trigger: 'blur'
          },
          CustomerAddress: {
            required: true,
            message: '请输入客户单位地址',
            trigger: 'blur'
          },
          InjuryAddress: {
            required: true,
            message: '请输入发生事故地址',
            trigger: 'blur'
          },
          PartyLaborContract: {
            required: true,
            message: '请输入劳动合同甲方',
            trigger: 'blur'
          },
          PositionInjury: {
            required: true,
            message: '请输入工伤发生时岗位',
            trigger: 'blur'
          },
          InjuryDetails: {
            required: true,
            message: '请输入事故经过',
            trigger: 'blur'
          },
          ApproximateCost: {
            required: true,
            message: '请输入大致费用',
            trigger: 'blur'
          },
          FullNameFirstHospital: {
            required: true,
            message: '请输入首次就诊医院全称',
            trigger: 'blur'
          },
          Diagnosis: {
            required: true,
            message: '请输入诊断结论',
            trigger: 'blur'
          },
          DoctorAdvice: {
            required: true,
            message: '请输入医生建议',
            trigger: 'blur'
          },
          InsurePosition: {
            required: true,
            message: '请输入商保参保时岗位',
            trigger: 'blur'
          },
          InsureCategory: {
            required: true,
            message: '请输入商保参保时职业类别',
            trigger: 'blur'
          },
          IsHospitalized: {
            required: true,
            message: '请选择是否住院',
            trigger: 'change'
          },
          InjuryDegree: {
            required: true,
            message: '请选择工伤程度',
            trigger: 'change'
          },
          IsTrafficInjury: {
            required: true,
            message: '请选择是否上下班途中交通事故',
            trigger: 'change'
          },
          LiabilityJudTrafficInjury: {
            required: true,
            message: '请选择交通事故员工的责任判定',
            trigger: 'change'
          },
          WorkplaceInjuryPlace: {
            required: true,
            message: '请选择工伤发生地（省市）',
            trigger: 'change'
          },
          FullNameSocialSecurity: {
            required: true,
            message: '请输入第一申报方（社保全称）',
            trigger: 'blur'
          },
          InInsureTime: {
            required: true,
            message: '请选择参保时间1',
            trigger: 'change'
          },
          SecondApplicant: {
            required: true,
            message: '请选择第二申报方（商保1）',
            trigger: 'change'
          },
          InInsureTime2: {
            required: true,
            message: '请选择参保时间2',
            trigger: 'change'
          },
          ThirdReporting: {
            required: true,
            message: '请选择第三申报方（商保2）',
            trigger: 'change'
          },
          InInsureTime3: {
            required: true,
            message: '请选择参保时间3',
            trigger: 'change'
          },
          Remark: {
            required: true,
            message: '请输入工伤事故报告备注',
            trigger: 'blur'
          },
        },
        provinces: [], //省列表
        propsAddress: {
          label: "Name",
          value: "Name",
          children: "children"
        },
        insureList: [], //险种列表
        proNameList: [], //项目列表
        legList: [], //
      }
    },
    created() {
      this.getProList();
      this.getprovinces();
      this.getInsurancManageByUserid();
      this.getWIAccidentReportList();
      this.getlegalsubjectlist();
    },
    methods: {
      checkPermission,
      //获取省市区
      getprovinces() {
        xz.getAreaAll().then((res) => {
          if (res != undefined && res.length > 0) {
            res.forEach(element => {
              if (element.children != undefined && element.children.length > 0) {
                element.children.forEach(e => {
                  delete e.children
                })
              }
            });
            this.provinces = res
          }
        })
      },
      //获取商保险种
      getInsurancManageByUserid() {
        let data = {
          pageNum: 1,
          pageSize: 1000
        }
        xz.getInsurancManageByUserid(data, this.roletype).then((res) => {
          if (res.status == "ok") {
            this.insureList = res.data.list;
          } else {
            this.insureList = [];
          }
        })
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      //选择省市
      changeCity() {
        this.formData.WorkplaceInjuryPlace = this.city.toString().replace(',', '-')
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getWIAccidentReportList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getWIAccidentReportList();
      },
      searchHandle() {
        this.listQuery.pageNum = 1;
        this.getWIAccidentReportList();
      },
      getWIAccidentReportList() {
        this.loading = true;
        xz.getWIAccidentReportList(this.listQuery, this.roletype).then(res => {
          if (res.status == "ok") {
            this.tableData = res.data.data;
            this.totalCount = res.data.totalcount;
            this.loading = false;
          } else {
            this.loading = false;
            this.tableData = [];
          }
        })
      },
      //新增事故报告
      addNewAcd() {
        this.clearForm();
        this.showAdd = true;
      },
      editAcd(item) {
        xz.getWIAccidentReport(item.Id, this.roletype).then(res => {
          if (res.status == "ok") {
            this.formData = res.data;
            this.city = res.data.WorkplaceInjuryPlace.split('-');
          } else {
            this.formData = item;
            this.city = item.WorkplaceInjuryPlace.split('-');
          }
          this.showAdd = true;
        })
      },
      clearForm() {
        this.city = '';
        this.formData = {
          Id: '',
          Idcard: '', //身份证
          TimeInjury: '', //发生工伤时间（年-月-日）
          InjuredEmployeeName: '', //工伤员工姓名
          ProjectName: '', //项目名称
          Service: '', //客服
          ServicePhone: '', //客服联系电话
          BranchOffice: '', //分公司
          MainBusiContract: '', //主商务合同（法务主体）全称
          TimeInjury1: '', //发生工伤时间点（几点几分）
          EmployeeEduc: '', //员工学历
          EmployeePhone: '', //员工联系电话
          FullNameCustomer: '', //客户单位全称
          CustomerAddress: '', //客户单位地址
          InjuryAddress: '', //发生事故地址
          PartyLaborContract: '', //劳动合同甲方
          PositionInjury: '', //工伤发生时岗位
          InjuryDetails: '', //事故经过
          ApproximateCost: '', //大致费用
          FullNameFirstHospital: '', //首次就诊医院全称
          Diagnosis: '', //诊断结论
          DoctorAdvice: '', //医生建议
          InsurePosition: '', //商保参保时岗位
          InsureCategory: '', //商保参保时职业类别
          IsHospitalized: '', //是否住院
          InjuryDegree: '', //工伤程度
          IsTrafficInjury: '', //是否上下班途中交通事故
          LiabilityJudTrafficInjury: '', //交通事故员工的责任判定
          WorkplaceInjuryPlace: '', //工伤发生地（省市）
          FullNameSocialSecurity: '', //第一申报方（社保全称）
          InInsureTime: '', //参保时间1
          SecondApplicant: '', //第二申报方（商保1）
          InInsureTime2: '', //参保时间2
          ThirdReporting: '', //第三申报方（商保2）
          InInsureTime3: '', //参保时间3
          Remark: '', //工伤事故报告备注
        }
      },
      //新增/修改
      confirmSubmit() {
        this.$refs["formData"].validate((valid) => {
          if (valid) {
            xz.updataWIAccidentReport(this.formData, this.roletype).then(res => {
              if (res.status == "ok") {
                this.showAdd = false;
                this.getWIAccidentReportList();
                this.$message.success('新增成功！')
              } else {
                this.showAdd = false;
                this.$message.error(res.msg)
              }
            })
          }
        })
      },
      delAcd(item) {
        xz.delWIAccidentReport(item.Id, this.roletype).then(res => {
          if (res.status == "ok") {
            this.getWIAccidentReportList();
            this.$message.success('作废成功！')
          } else {
            this.getWIAccidentReportList();
            this.$message.error(res.msg)
          }
        })
      },
      //导出报告
      getReport(row) {
        xz.exportInjuryReport(row.Id, this.roletype).then(res => {
          if (res.status == "ok") {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a")
            aLink.download = row.ProjectName + row.InjuredEmployeeName + '工伤报告' + row.TimeInjury + '.zip' //这里写保存时的图片名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          pageNum: '1',
          pageSize: '10000'
        }
        xz.getlegalsubjectlist(data).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.data;
          } else {
            this.legList = [];
          }
        })
      },
      //根据身份证号获取信息
      getIdcardInfo(chkval, callback) {
        if (this.formData.Idcard.length == 18) {
          xz.getWorkAccidentProjectById(this.formData.Idcard, this.roletype).then(res => {
            if (res.status == "ok") {
              if (res.data.StrEmpName != undefined && res.data.StrEmpName && this.formData.InjuredEmployeeName != res.data.StrEmpName) {
                this.formData.InjuredEmployeeName = res.data.StrEmpName;
                this.formData.ProjectName = res.data.StrprojectName;
                this.formData.Service = res.data.Service;
                this.formData.ServicePhone = res.data.Servicemobile;
                this.formData.PositionInjury = res.data.JobName;
                this.formData.InsureCategory = res.data.JobClasss;
                this.formData.SecondApplicant = res.data.InsuranceName;
                this.formData.InInsureTime2 = res.data.CoverStartTime;
                this.formData.MainBusiContract = res.data.ContractParty;
                this.formData.BranchOffice = res.data.BranchOffice;
                this.formData.FullNameCustomer = res.data.ActualWorkUnit;
                callback(true)
              } else {
                callback(true);
              }
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .agg {
    font-weight: 600;
  }

  .tipsItem {
    margin-top: 10px;
  }
</style>
<style>
  .page_injuryTables .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_injuryTables .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_injuryTables .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_injuryTables .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_injuryTables .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_injuryTables .formData .el-form-item {
    margin-bottom: 10px;
  }

  .page_injuryTables .formData .el-form-item__error {
    top: 34px;
  }

  .page_injuryTables .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_injuryTables .formData .el-icon-question:before {
    color: #F56C6C;
  }

  .page_injuryTables .formData .injuryTextarea .el-form-item__error {
    top: 75px;
  }
</style>